import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";
import { FormControl } from "@/components/ui/form.tsx";
import { SignupQuestion } from "@/lib/signupQuestion.ts";
import { useTranslation } from "@/i18n";

// Radix Select doesn't allow an empty string as an item value.
const NO_ANSWER = "__no_answer__";

const SignupQuestionSelect = ({
  question,
  value,
  onChange,
  disabled,
  savedAnswer,
}: {
  question: SignupQuestion;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  // The player's saved answer, kept in the list even if the admin has since
  // renamed or removed that option so it still shows as selected.
  savedAnswer?: string | null;
}) => {
  const { t } = useTranslation();
  const options =
    savedAnswer && !question.options.includes(savedAnswer)
      ? [...question.options, savedAnswer]
      : question.options;

  return (
    <Select
      value={value}
      onValueChange={(newValue) =>
        onChange(newValue === NO_ANSWER ? "" : newValue)
      }
      disabled={disabled}
    >
      <FormControl>
        <SelectTrigger>
          <SelectValue placeholder={t("form.selectAnOption")} />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {!question.required && (
          <SelectItem value={NO_ANSWER}>{t("form.noAnswer")}</SelectItem>
        )}
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SignupQuestionSelect;
